module.exports = __webpack_public_path__ + "images/hero-foto.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-foto.jpg
// module id = 20
// module chunks = 1